import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts';

interface CustomerData {
    customer_name: string;
    total_spent: number;
}

const COLORS = ['#FF5733', '#33FF57', '#3357FF', '#F333FF', '#FF33A6'];

const TopCustomersDoughnutChart: React.FC = () => {
    const [topCustomers, setTopCustomers] = useState<CustomerData[]>([]);

    useEffect(() => {
        const fetchTopCustomers = async () => {
            try {
                const response = await axios.get('https://api.sominnovations.xyz/Branches/top_customers/');
                setTopCustomers(response.data);
            } catch (error) {
                console.error('Error fetching top customers:', error);
            }
        };

        fetchTopCustomers();
    }, []);

    return (
        <div className="container mt-4">
            <div className="row">
                <div className="col-12">
                    <div className="card shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center mb-4">Top Customers (Current Month)</h5>
                            <div style={{ width: '100%', height: 400 }}>
                                <ResponsiveContainer>
                                    <PieChart>
                                        <Pie
                                            data={topCustomers}
                                            dataKey="total_spent"
                                            nameKey="customer_name"
                                            cx="50%"
                                            cy="50%"
                                            innerRadius={60} // Set inner radius for doughnut effect
                                            outerRadius={80}
                                            fill="#8884d8"
                                            label
                                        >
                                            {topCustomers.map((_, index) => (
                                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                            ))}
                                        </Pie>
                                        <Tooltip />
                                        <Legend />
                                    </PieChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopCustomersDoughnutChart;
